import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: JSON.parse(localStorage.getItem('userData')) || null,
  funding_bal: localStorage.getItem('funding_bal') || 0,
  sub_bal: localStorage.getItem('sub_bal') || 0,
  ref_bal: localStorage.getItem('ref_bal') || 0,
  withdrawableBalance: localStorage.getItem('withdrawableBalance') || 0,
  loading: false,
  error: null
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      localStorage.setItem('userData', JSON.stringify(action.payload));
    },
    setUserData: (state, action) => {
      state.user = action.payload;
      localStorage.setItem('userData', JSON.stringify(action.payload));
    },
    setBalances: (state, action) => {
      state.funding_bal = action.payload.funding_bal;
      state.sub_bal = action.payload.sub_bal;
      state.ref_bal = action.payload.ref_bal;
      state.withdrawableBalance = action.payload.withdrawableBalance;
      
      localStorage.setItem('funding_bal', action.payload.funding_bal);
      localStorage.setItem('sub_bal', action.payload.sub_bal);
      localStorage.setItem('ref_bal', action.payload.ref_bal);
      localStorage.setItem('withdrawableBalance', action.payload.withdrawableBalance);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.funding_bal = 0;
      state.sub_bal = 0;
      state.ref_bal = 0;
      state.withdrawableBalance = 0;
      
      localStorage.removeItem('userData');
      localStorage.removeItem('funding_bal');
      localStorage.removeItem('sub_bal');
      localStorage.removeItem('ref_bal');
      localStorage.removeItem('withdrawableBalance');
    }
  }
});

export const { setUser, setUserData, setBalances, setLoading, setError, clearUser } = userSlice.actions;

export default userSlice.reducer;
